

































































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading'
import { EventEmitter } from 'events'
import { PaginateTypes } from '@/store/medicine/index'

export type InputMedicineValues = {
  productName: string
  yjCode: string
}

const enum EventTypes {
  CREATED
}

@Component({
  components: {
    InfiniteLoading: InfiniteLoading,
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MedicineModal extends Vue {
  $store!: ExStore

  inputSelectedMedicineId: number | null = null
  innerInputeSearchKeyword = ''

  showLoading = false
  isCreated = false
  events = new EventEmitter()
  timeoutId: null | number = null

  get medicines() {
    return this.$store.getters['medicine/medicines']
  }

  get medicineIds() {
    return this.$store.getters['medicine/sort']
  }

  get hasNextPage() {
    return this.$store.getters['medicine/hasNext']
  }

  get inputeSearchKeyword() {
    return this.innerInputeSearchKeyword
  }

  set inputeSearchKeyword(newValue: string) {
    if (this.innerInputeSearchKeyword === newValue) {
      return
    }

    this.innerInputeSearchKeyword = newValue

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
    }

    this.timeoutId = setTimeout(
      () => this.handleChangeSearchKeyword(newValue),
      300
    )
  }

  handleClickCloseButton() {
    this.$emit('close')
  }

  handleClickDecision() {
    if (!this.inputSelectedMedicineId) {
      return
    }
    const { productName, yjCode } = this.medicines[this.inputSelectedMedicineId]
    this.$emit('decide', { productName, yjCode })
  }

  handleChangeSearchKeyword(query: string) {
    this.$store.dispatch('medicine/fetch', { query })
  }

  async handleReachEnd($state: StateChanger) {
    if (!this.isCreated) {
      this.events.once(EventTypes.CREATED, $state.loaded.bind($state))
      return
    }

    try {
      if (!this.hasNextPage) {
        $state.complete()
        return
      }

      this.showLoading = true

      await this.$store.dispatch('medicine/paginate', {
        direction: PaginateTypes.NEXT
      })

      $state.loaded()
    } catch (error) {
      console.error(error)
      $state.complete()
    } finally {
      this.showLoading = false
    }
  }

  async created() {
    await this.$store.dispatch('medicine/fetch')
    this.isCreated = true
    this.events.emit(EventTypes.CREATED)
  }
}
